/**
 * /app/$tenantSlug/wfh/approvals — old WFH approvals queue. It now lives in Inbox →
 * Approvals (wfh tab), so this URL redirects there (bookmarks and stored
 * notification links keep working; any other query is dropped — the
 * queue has no filters of its own).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/wfh/approvals",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/approvals",
      params: { tenantSlug: params.tenantSlug },
      search: { tab: "wfh" },
      replace: true,
    });
  },
});
